import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'i18n';
import { USER_FLAGS } from 'config';
import { fetchBalance } from 'actions/profile';
import withMouseControls from 'components/HOCs/withMouseControls';
import Profile from 'components/Profile';
import { getProfileData, getIsLoggedInSelector, getLoginData } from 'reducers/profile/selectors';

const ITEMS = [
  { id: 'authorization', title: i18n.t('profile.account'), path: 'authorization' },
  { id: 'user-packages', title: i18n.t('packages.title'), path: 'packages/all' },
  { id: 'promocode', title: i18n.t('profile.promocodeItem'), path: 'promocode' },
  { id: 'settings', title: i18n.t('profile.settings'), path: 'settings' },
  { id: 'terms', title: i18n.t('profile.terms'), path: 'terms' },
];

const ProfilePage = ({ history, match }) => {
  const dispatch = useDispatch();
  const profileData = useSelector(getProfileData);
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const loginData = useSelector(getLoginData);

  const items = useMemo(() => {
    const isLifecellUser = loginData?.userFlag === USER_FLAGS.LIFECELL;
    const profileListData = ITEMS.map(({ id, title, path, name }) => {
      let metadata = '';

      if (id === 'authorization' && isLoggedIn) {
        metadata = isLifecellUser ? loginData.phone : profileData.contractNumber;
      } else if (id === 'user-packages' && profileData.balance && !isLifecellUser) {
        const { balance } = profileData;
        metadata = `${i18n.t('profile.balance')}: ${balance.balance} ${balance.currency}`;
      }
      return { id, title, path, name, metadata };
    });

    return profileListData;
  }, [isLoggedIn, loginData, profileData]);

  return (
    <Profile
      data={profileData}
      items={items}
      history={history}
      match={match}
      isLoggedIn={isLoggedIn}
      fetchBalance={() => dispatch(fetchBalance())}
    />
  );
};

export default withMouseControls(ProfilePage);
